import styled from "styled-components";
import { Line } from "react-chartjs-2";
import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  LinearProgress,
  Paper as MuiPaper,
} from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { useComponent } from "../../../hooks";
import startDateCalculator from "./startDateCalculator";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LinearScale,
  PointElement,
  LineElement,
  CategoryScale
);

const Paper = styled(MuiPaper)`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
`;

const ContainerItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export default function ChatBotDisplayOne({ botID, startDate }) {
  const { axios } = useComponent();
  const [loading, setLoading] = useState(true);
  const [sessions, setSessions] = useState({});

  useEffect(() => {
    setLoading(true);

    axios({
      url: `/insights/session_graphs/${botID}`,
      disableError: true,
      disableRedirect: true,
      params: {
        end_date: new Date().getTime() / 1000,
        ...(startDate !== -1 && { start_date: startDateCalculator(startDate) }),
      },
    }).then((response) => {
      if (response.status) {
        setSessions({
          labels: response.data.label,
          datasets: response.data.dataset,
        });

        setLoading(false);
      }
    });
  }, [axios, botID, startDate]);

  const config = {
    type: "line",
    data: sessions,
    options: {
      responsive: true,
      plugins: {
        title: {
          display: true,
        },
      },
      interaction: {
        intersect: false,
      },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: "Value",
          },
          suggestedMin: -10,
          suggestedMax: 200,
        },
      },
    },
  };

  return (
    <Paper style={{ height: { lg: "390px", sm: "350px" } }}>
      {loading ? (
        <LinearProgress style={{ width: "80%" }} />
      ) : (
        <Fragment>
          <Container>
            <Grid
              container
              spacing={2}
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid
                item
                xs={8}
                sm={10}
                md={12}
                lg={12}
                xl={11}
                style={{ justifyContent: "center", alignItems: "center" }}
              >
                <ContainerItem>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: { lg: 17, md: 17, sm: 17, xs: 15 },
                      alignItems: "center",
                    }}
                  >
                    Number of Sessions
                  </Typography>

                  <Line data={sessions} options={config} />
                </ContainerItem>
              </Grid>
            </Grid>
          </Container>
        </Fragment>
      )}
    </Paper>
  );
}
